import {
  SET_BANKS
} from 'src/store/mutation-types'
export default {
  [SET_BANKS] (state, data) {
    state.banks = data
  }
}



// WEBPACK FOOTER //
// ./src/components/bank/store/mutations.js